(function() {

    var lightbox = '.js-product-images-lightbox';
    var $lightbox = $(lightbox);

    // ====================================================================== //
    // On ready
    // ====================================================================== //

    onReady.callbacks.lightbox = function() {
        $lightbox.spLightbox({
            loaderHtml: '<div class="c-spinner c-products__spinner"><b class="u-visually-hidden">Loading&amp;</b></div>',
            onBeforeOpen: function() {
                _pauseScroll( 'lightbox' );
            },
            onAfterClose: function() {
                _resumeScroll( 'lightbox' );
            },
            srcset: true
        });
    };

})();
